import {
  Box,
  EmptyState,
  Flex,
  Loader,
  Panel,
  PanelHeader,
  Text,
} from "@coaching-culture/ui";
import { useUser } from "auth";
import { useMeasures, useUserMeasures } from "queries/measures";
import { useEffect, useState } from "react";
import { FaChartLine } from "react-icons/fa";
import { DualOptionSelect } from "./DualOptionSelect";
import { MeasuresTable } from "./MeasuresTable";

export const MeasuresComparison = () => {
  const [selected, setSelected] = useState<[string, string]>(["", ""]);
  const [user] = useUser();
  const measures = useMeasures();
  const userMeasures = useUserMeasures(user.id);

  useEffect(() => {
    if (measures.data?.length > 1) {
      setSelected([measures.data?.[0].id ?? "", measures.data?.[1].id ?? ""]);
    }
  }, [measures.data]);

  const loading = !measures.isSuccess || !userMeasures.isSuccess;

  const noData = measures.data?.length < 2;

  return (
    <Panel mb={3}>
      <PanelHeader alignItems={"center"}>
        <Text as="h2" m={0} fontSize="title" fontWeight={600}>
          Measures insights
        </Text>
      </PanelHeader>
      {loading ? (
        <Loader />
      ) : noData ? (
        <EmptyState compact icon={FaChartLine}>
          Add at least two measures to compare them here.
        </EmptyState>
      ) : (
        <Flex p={3} alignItems={"center"} flexDirection={["column", "row"]}>
          <Box p={4} ml={2} mr={1}>
            <DualOptionSelect
              options={measures.data.map((x) => ({
                value: x.id,
                label: x.name,
              }))}
              value={selected}
              onChange={setSelected}
            />
          </Box>
          <Box overflowX={"auto"} flex="1">
            <MeasuresTable
              comparison={selected}
              measures={measures.data}
              userMeasures={userMeasures.data}
            />
          </Box>
        </Flex>
      )}
    </Panel>
  );
};
